import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { getWaMode, setWaMode, WA_MODES } from "../lib/whatsapp";

export function WaOpenModeBox({ className = "" }) {
  const [mode, setMode] = useState(getWaMode());
  const pick = (m) => { setWaMode(m); setMode(m); };
  return (
    <div className={`rounded-2xl border border-[#e8dcc8] bg-white p-4 ${className}`} data-testid="wa-open-mode-box">
      <div className="font-bold text-sm mb-1 inline-flex items-center gap-2"><MessageCircle className="h-4 w-4 text-[#25D366]" /> Come aprire WhatsApp dai tasti dell'app (su questo dispositivo)</div>
      <p className="text-xs text-[#7c5a4e] mb-3">"Browser" apre WhatsApp Web / wa.me con il messaggio pronto (come sempre). "App installata" prova ad aprire direttamente l'app WhatsApp del dispositivo e, se non risponde, ripiega sul browser.</p>
      <div className="flex flex-wrap gap-2">
        {WA_MODES.map(([k, label]) => (
          <button key={k} type="button" onClick={() => pick(k)} className={`rounded-full px-3 py-1.5 text-xs font-semibold border ${mode === k ? "bg-[#4a1c17] text-white border-[#4a1c17]" : "bg-white text-[#4a1c17] border-[#e8dcc8]"}`} data-testid={`wa-open-mode-${k}`}>{label}</button>
        ))}
      </div>
    </div>
  );
}
